import React, { useEffect } from "react";
import styled from "styled-components";
import { Tabs, Tab } from "../../components/Tab";

import PosPage from "../servicePage/pos";
import KdsPage from "../servicePage/kds";
import KioskPage from "../servicePage/kiosk";
import DidPage from "../servicePage/did";
import TableOrederPage from "../servicePage/tableOreder";
import OnlineOrederPage from "../servicePage/onlineOreder";

const ServicePage = () => {
  return (
    <Style>
      <div className="serviceWrap">
        <div className="tabContentWrap">
          <Tabs>
            <Tab label="POS">
              <PosPage />
            </Tab>
            <Tab label="KDS">
              <KdsPage />
            </Tab>
            <Tab label="KIOSK">
              <KioskPage />
            </Tab>
            <Tab label="DID">
              <DidPage />
            </Tab>
            <Tab label="TABLE ORDER">
              <TableOrederPage />
            </Tab>
            <Tab label="ONLINE ORDER">
              <OnlineOrederPage />
            </Tab>
          </Tabs>
        </div>
      </div>
    </Style>
  );
};

export default ServicePage;
const Style = styled.div`
  .mobileView {
    display: none;
  }

  .serviceWrap {
    width: 100%;
  }

  /* tabWrap */
  .tabWrap {
    width: 100%;
    justify-content: center;
    padding-top: 100px;

    .tabContent {
      padding: 10px 40px;
      font-size: 18px;
      font-weight: 500;
      color: #979797;
    }
    .tabContent.active {
      padding: 11px 40px;
    }
  }

  @media (max-width: 1100px) {
    .webView {
      display: none;
    }
    .mobileView {
      display: block;
    }

    .tabWrap {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      padding: 100px 4vw 0 4vw;
      gap: 6px;

      .tabContent,
      .tabContent.active {
        width: 30%;
        min-height: 62px;
        padding: 11px;
        border-radius: 10px;
        font-size: 16px;
        font-weight: 500;
        white-space: pre-line;
        box-shadow: none;
      }
      .tabContent.active {
        font-weight: 700;
      }
    }
    .subTabWrap {
      min-height: 280px;

      .tabWrap {
        padding: 20px 0 0 0;
        gap: 5px;

        .tabContent,
        .tabContent.active {
          width: auto;
          min-height: auto;
          padding: 10px 11px !important;
          border-radius: 50px;
          font-size: 12px;
        }
      }
    }
  }
`;
